var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 7,
    viewBox: "0 0 12 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9998 0.000213623C11.1975 0.000256062 11.3908 0.0589275 11.5552 0.168812C11.7197 0.278696 11.8478 0.43486 11.9235 0.617559C11.9991 0.800259 12.0189 1.00129 11.9804 1.19524C11.9418 1.3892 11.8466 1.56736 11.7068 1.70721L6.70679 6.70721C6.51926 6.89468 6.26495 7 5.99979 7C5.73462 7 5.48031 6.89468 5.29279 6.70721L0.292787 1.70721C0.152978 1.56736 0.057771 1.3892 0.0192034 1.19524C-0.0193641 1.00129 0.000439122 0.800259 0.0761092 0.617559C0.151779 0.43486 0.279919 0.278696 0.444329 0.168812C0.608738 0.0589275 0.802037 0.000256062 0.999787 0.000213623H10.9998Z",
    fill: "#FF3093"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropArrow);
export default __webpack_public_path__ + "static/media/dropArrow.c2e655d588bf797a91cc15e1695d13fb.svg";
export { ForwardRef as ReactComponent };